import React from 'react';
import { Helmet } from 'react-helmet';
import { MdDelete } from 'react-icons/md';

// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import PageTitleAndFilters from 'components/PageTitleAndFilters';
import PageTitleAndFiltersPusher from 'components/PageTitleAndFiltersPusher';
import SaveMessage from 'components/SaveMessage';
import RoleButton from 'components/RoleButton';
import { ADMIN, MANAGER } from 'components/RoleGate/constants';
import {
    CREATE_MODAL_QUERY_STRING_PARAM,
    DELETE_MODAL_QUERY_STRING_PARAM
} from 'components/VirtualizedTable/constants';
import ButtonIconWrapper from 'components/ButtonIconWrapper';
import SingleActiveTableRowGate from 'components/SingleActiveTableRowGate';

import ActiveIngredientsVirtualizedTable from './components/ActiveIngredientsVirtualizedTable';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

export class ActiveIngredients extends React.PureComponent<{}> {
    render(): React.ReactElement {
        return (
            <ErrorBoundary
                namespace="ActiveIngredients"
                FallbackComponent={<ErrorBoundaryAlert />}
            >
                <Helmet>
                    <title>Active Ingredients - {REACT_APP_PROJECT_NAME}</title>
                </Helmet>
                <PageTitleAndFilters
                    title="Active Ingredients"
                    searchInputPlaceholder="Search"
                    hideFilters
                    MessageComponent={
                        <SaveMessage
                            namespace={[
                                'ACTIVE_INGREDIENT_CREATE',
                                'ACTIVE_INGREDIENT_UPDATE',
                                'ACTIVE_INGREDIENT_DELETE'
                            ]}
                        />
                    }
                    FirstActionButton={
                        <SingleActiveTableRowGate>
                            <RoleButton
                                requiredRoles={[ADMIN, MANAGER]}
                                params={{
                                    [DELETE_MODAL_QUERY_STRING_PARAM]: true
                                }}
                                buttonProps={{
                                    icon: true,
                                    color: 'black',
                                    basic: true,
                                    style: {
                                        marginRight: 0,
                                        marginLeft: 8
                                    }
                                }}
                            >
                                <ButtonIconWrapper>
                                    <MdDelete
                                        style={{
                                            fontSize: 20
                                        }}
                                    />
                                </ButtonIconWrapper>
                                Delete
                            </RoleButton>
                        </SingleActiveTableRowGate>
                    }
                    SecondActionButton={
                        <RoleButton
                            requiredRoles={[ADMIN, MANAGER]}
                            params={{
                                [CREATE_MODAL_QUERY_STRING_PARAM]: true
                            }}
                            buttonProps={{
                                secondary: true,
                                style: {
                                    marginRight: 0,
                                    marginLeft: 8
                                }
                            }}
                        >
                            Create New
                        </RoleButton>
                    }
                />
                <PageTitleAndFiltersPusher>
                    <ActiveIngredientsVirtualizedTable tableId="active-ingredients" />
                </PageTitleAndFiltersPusher>
            </ErrorBoundary>
        );
    }
}

export default ActiveIngredients;
